export const getJobberClientId = (): string => {
    if (process.env.VOICIFY_ENVIRONMENT === "dev" || process.env.VOICIFY_ENVIRONMENT === "staging") {
        return "629d308a-d15f-4e28-81f0-756a81c19074";
    }
    return "5b9c7628-39b6-4d1e-aa27-6705e68bfb61"; // production
};

